<template>
  <hm-content title="">
    <div class="mb10"></div>
    <div class="table-panel">
      <span class="mr10" style="fontWeight:600">代理标签 </span>
      <el-button type="primary" size="small" @click="add"
        >新增代理标签</el-button
      >
    </div>
    <div class="table mb20">
      <el-table
        stripe
        border
        ref="table"
        :data="list"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="titleName"
          label="标签名称"
        >
        </el-table-column>
        <el-table-column
          prop="agentIcon"
          header-align="center"
          align="center"
          label="代理图标"
        >
          <template slot-scope="scope">
            <el-image
              style="width: 100px; height: 100px"
              :src="scope.row.agentIcon"
              :preview-src-list="[scope.row.agentIcon]"
            >
            </el-image>
          </template>
        </el-table-column>

        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button
                size="small"
                @click="remove(scope.row)"
                class="blue"
                type="text"
                >删 除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="personal-store mb20">
      <div>
        <span style="fontWeight:600">代理个人店：</span>
        <el-switch
          v-model="personalStoreState"
          active-color="#2d8"
          inactive-color="#ff4949"
          active-text="开启"
          inactive-text="关闭"
          active-value="open"
          inactive-value="close"
          @change="switchPersonalStoreState"
        ></el-switch>
      </div>
      <div class="tips-wrapper">
        <div class="tips">
          个人店铺开启后，将在商城显示分享人所属代理的店铺名、logo、
          店铺背景，具体样式如下图。
        </div>
        <div class="flex">
          <div class="img-wrapper">
            <img
              src="https://imgcdn.hemiao100.com/hemiaoBase/mallDecoration/1586404563025-b3ca1805-a3f6-49fa.png"
              alt=""
            />
          </div>
          <div class="img-wrapper">
            <img
              src="https://imgcdn.hemiao100.com/hemiaoBase/mallDecoration/1586403916685-b616ae2b-15ee-451b.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <div class="table-panel" style="fontWeight:600">代理规则编辑</div>
    <div>
      <hm-rich-editor v-model="textContentZhCn" :html="textContentZhCn" />
    </div>
    <div class="flex flex-center mt20">
      <el-button type="primary" size="small" @click="save">确 认</el-button>
      <el-button size="small" @click="$router.back(-1)">返 回</el-button>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      title="新增代理标签"
      :visible.sync="dialogVisible"
    >
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="100px"
      >
        <el-form-item label="标签名称" prop="titleName">
          <el-input
            v-model.trim="ruleForm.titleName"
            maxlength="20"
            size="small"
            placeholder="请输入单行文本，限制20个字符"
          ></el-input>
        </el-form-item>
        <el-form-item label="代理图标" prop="agentIcon">
          <div class="flex upload-upload-btn">
            <div
              class="btn flex flex-column flex-center open-file"
              @click="show = true"
              v-if="!ruleForm.agentIcon"
            >
              <div class="add-wrapper">
                <span class="hmicon icon-hao pointer"></span>
              </div>
              <span>添加图片</span>
            </div>
            <div v-if="ruleForm.agentIcon" class="mr10 flex item-end priview">
              <img class="logo" :src="ruleForm.agentIcon" alt="logo" />
              <div class="opreat-wrapper flex item-center flex-center">
                <el-button type="text" @click="handleRemove">删除</el-button>
              </div>
            </div>
            <div class="flex flex-column flex-end">
              <div class="tips">只能上传jpg/png文件，且不能超过1MB</div>
              <div class="tips">建议图片尺寸为400x400像素(最多上传一张）</div>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer flex flex-center mt20">
        <el-button @click="submitForm('ruleForm')" size="small" type="primary">
          确 认</el-button
        >
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <my-upload
      field="file"
      @crop-upload-success="cropUploadSuccess"
      v-model="show"
      noCircle
      noSquare
      :width="400"
      :height="400"
      :headers="{ 'X-Access-Token': $token }"
      :params="{ fileDir: 'goodsCenter' }"
      :url="$uploadUrl"
      img-format="png"
    ></my-upload>
  </hm-content>
</template>

<script>
import HmRichEditor from "@/components/HmRichEditor";
import myUpload from "vue-image-crop-upload";
export default {
  components: { HmRichEditor, myUpload },
  data() {
    return {
      dialogVisible: false,
      show: false,
      personalStoreState: "open",
      ruleForm: {
        titleName: "",
        agentIcon: ""
      },
      rules: {
        titleName: {
          required: true,
          trrger: "blur",
          message: "请输入标签名"
        },
        agentIcon: {
          required: true,
          trrger: "blur",
          message: "请选择代理图标"
        }
      },
      currentPage: 1,
      pageSize: 10,
      list: [],
      textContentZhCn: "",
      textId: ""
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryList();
    this.queryShareAgentRule();
    this.queryPersonalStoreState();
  },
  methods: {
    async queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      const { result } = await this.$store.dispatch(
        "queryAgentTitleList",
        params
      );
      const { records, total } = result;
      this.list = records;
      this.total = total;
    },
    // 移除上传文件
    handleRemove() {
      this.ruleForm.agentIcon = "";
    },
    cropUploadSuccess(jsonData) {
      this.ruleForm.agentIcon = jsonData.result;
    },
    add() {
      this.dialogVisible = true;
    },
    async queryPersonalStoreState() {
      const { result } = await this.$store.dispatch("queryPersonalStoreState", {
        code: "personalStoreState"
      });
      if (result) {
        this.personalStoreState = result.value;
      } else {
        await this.$store.dispatch("addPersonalStoreState", {
          code: "personalStoreState",
          value: "open"
        });
        this.queryPersonalStoreState();
      }
    },
    async switchPersonalStoreState() {
      const { code } = await this.$store.dispatch("editPersonalStoreState", {
        code: "personalStoreState",
        value: this.personalStoreState
      });
      if (code === "0") {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.queryPersonalStoreState();
      }
    },
    remove(row) {
      this.$confirm("是否确认删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let params = {
            delFlag: "1",
            agentTitleId: row.agentTitleId
          };
          this.$store.dispatch("removeAgentTitle", params).then(res => {
            if (res.code === "0") {
              this.$message({
                type: "success",
                message: "操作成功"
              });
              this.queryList();
            }
          });
        })
        .catch(() => {});
    },
    resetRuleForm() {
      this.$refs.ruleForm.resetFields();
    },
    async submitForm(formName) {
      const valid = await this.$refs[formName].validate();
      if (valid) {
        let params = this.ruleForm;
        const { code } = await this.$store.dispatch("addAgentTitle", params);
        if (code === "0") {
          this.$message({
            type: "success",
            message: "操作成功"
          });
          this.dialogVisible = false;
          setTimeout(() => {
            this.resetRuleForm(formName);
          }, 0);
          this.queryList();
        }
      }
    },
    async save() {
      let params = {
        textCode: "shareAgent",
        textContentZhCn: this.textContentZhCn,
        textName: "代理规则",
        textType: "text",
        textId: this.textId
      };
      const { code } = await this.$store.dispatch("addOrUpdate", params);
      if (code === "0") {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.queryShareAgentRule();
      }
    },
    async queryShareAgentRule() {
      let params = {
        textCode: "shareAgent"
      };
      const { result } = await this.$store.dispatch("queryByInfo", params);
      this.textContentZhCn = result.textContentZhCn;
      this.textId = result.textId;
    }
  }
};
</script>
<style lang="scss" scoped>
.modal-table {
  border: 1px solid #ddd;
  border-radius: 5px;
  text-align: center;
  .table-header {
    background: #f7f7f7;
    > div {
      padding: 15px;
      color: #222;
    }
  }
  .table-body {
    padding: 15px;
  }
}
.upload-upload-btn {
  .tips {
    color: #999;
    font-size: 12px;
    line-height: 20px;
  }

  .btn {
    border: 1px solid #ddd;
    text-align: center;
    padding: 10px;
    margin-right: 10px;
    width: 80px;
    height: 80px;
    cursor: pointer;
    .add-wrapper {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin: 0 auto;
      span {
        font-size: 12px;
      }
      cursor: pointer;
      .hmicon {
        font-size: 14px;
      }
    }
  }
}

.tips-wrapper {
  padding: 20px 0;
}

.img-wrapper {
  width: 200px;
  margin-top: 20px;
  margin-right: 20px;
  img {
    width: 100%;
  }
}

.priview {
  position: relative;
  .logo {
    width: 100px;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
</style>
